export interface OrgConfig {
  /** Header brand label (text only for now). Logo: src/assets/img/orgs/{orgId}.svg */
  name: string;
  bulkOrderUrl?: string;
  googleAnalyticsId?: string;
}

export enum SupportedOrgs {
  LCA = 'lca',
  PDT = 'pdt',
  AGD = 'agd',
}

export const ORG_CONFIGS: Record<SupportedOrgs, OrgConfig> = {
  [SupportedOrgs.LCA]: {
    name: 'Lambda Chi Alpha',
    bulkOrderUrl: 'https://enrichly.typeform.com/lcabulk',
    googleAnalyticsId: 'G-KD0KXXPHLF',
  },
  [SupportedOrgs.PDT]: {
    name: 'Phi Delta Theta',
    bulkOrderUrl: 'https://enrichly.typeform.com/to/t2LAS4Op',
    googleAnalyticsId: 'G-HDT1HFV8K8',
  },
  [SupportedOrgs.AGD]: {
    name: 'Alpha Gamma Delta',
    bulkOrderUrl: 'https://enrichly.typeform.com/AlphaGamma',
    googleAnalyticsId: 'G-LEJ0N1M7YE',
  },
};

export interface ProductOrgMetafields {
  organization_lca?: { value: string } | null;
  organization_pdt?: { value: string } | null;
  organization_agd?: { value: string } | null;
}

export function orgFromProduct(product: ProductOrgMetafields): SupportedOrgs | undefined {
  for (const orgId of Object.values(SupportedOrgs)) {
    const key = `organization_${orgId}` as keyof ProductOrgMetafields;
    if (product[key]?.value === '1') {
      return orgId as SupportedOrgs;
    }
  }
  return undefined;
}

export function isSupportedOrg(value: unknown): value is SupportedOrgs {
  return typeof value === 'string' && (Object.values(SupportedOrgs) as string[]).includes(value);
}

export function getOrgBrandName(orgId: SupportedOrgs | undefined): string | undefined {
  if (!orgId) {
    return undefined;
  }
  return ORG_CONFIGS[orgId]?.name;
}
